import React, {PureComponent, ReactNode} from "react"
import {Mutation, MutationFn, MutationResult} from "react-apollo"
import gql from "graphql-tag"

import {Mutation as MutationComponent} from "@irati/utils/services/apollo"
import API from "@irati/utils/services/API"

import companyValuesErrorHandler from "../../services/errors/companyValuesErrorHandler"
import {CompanyValue} from "../../types"

API.registerErrorHandlers([companyValuesErrorHandler])

const mutation = gql`
  mutation CreateCompanyValue($companyValue: CompanyValueInput!, $tenantId: String!) {
    createCompanyValue(companyValue: $companyValue, tenantId: $tenantId) {
      desc
      name
      tag
      icon {
        href
      }
      uuid
    }
  }
`

interface CreateCompanyValueData {
  companyValue: CompanyValue
}

interface CreateCompanyValueProps {
  children: (mutate: MutationFn, apolloState: MutationResult) => ReactNode,
  companyValue: CompanyValue,
  tenantId: string
}

class TypedMutation extends Mutation<CreateCompanyValueData> {}

export default class CreateCompanyValueMutation extends PureComponent<CreateCompanyValueProps> {
  render() {
    const {children, companyValue, tenantId} = this.props

    return (
      <MutationComponent mutation={mutation} MutationComponent={TypedMutation} {...this.props}>
        {(mutate: MutationFn, apolloState: MutationResult) =>
          children(
            (args: any) =>
              mutate({
                variables: {
                  companyValue,
                  tenantId
                },
                refetchQueries: ["CompanyValues"],
                awaitRefetchQueries: true,
                ...args
              }),
            apolloState
          )
        }
      </MutationComponent>
    )
  }
}
